import React from 'react';
import { Divider, Typography } from '@mui/material';

/**
 * Section header chrome for the JotMeet settings card.
 *
 * Matches the look of the other /user settings sections (Clinician, Languages,
 * Features, etc.): a bold h6 title, a horizontal divider, and an intro
 * paragraph below it.
 */
export const JotMeetHeader: React.FC = () => (
  <>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
      JotMeet
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
      See patients over video directly inside JotPsych. One permanent waiting-room link,
      yours forever.
    </Typography>
  </>
);
